import React from 'react';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import VulnerabilityReportContainer from '@totem/components/vulnerabilities/report/vulnerabilityReportContainer';
import VulnerabilityReportTable from '@totem/components/vulnerabilities/report/vulnerabilityReportTable';

const DeviceVulnerabilityReportPage = () => {
  return (
    <ContentLayout>
      <IBCard isCovered>
        <VulnerabilityReportContainer>
          <VulnerabilityReportTable />
        </VulnerabilityReportContainer>
      </IBCard>
    </ContentLayout>
  );
};

export default DeviceVulnerabilityReportPage;
